"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setVersion_1 = require("./setVersion");
exports.setVersion = setVersion_1.setVersion;
setVersion_1.setVersion('@uifabric/set-version', '6.0.0');
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/set-version/lib-commonjs/index.js
// module id = 465
// module chunks = 0